module.exports = __webpack_public_path__ + "static/media/multiply_down.4fe3d5c0.mp3";